const OPEN_AI_CHAT = 'scratch-gui/ai-chat/OPEN_AI_CHAT';
const CLOSE_AI_CHAT = 'scratch-gui/ai-chat/CLOSE_AI_CHAT';
const TOGGLE_AI_CHAT = 'scratch-gui/ai-chat/TOGGLE_AI_CHAT';
const ADD_AI_MESSAGE = 'scratch-gui/ai-chat/ADD_AI_MESSAGE';
const SET_AI_LOADING = 'scratch-gui/ai-chat/SET_AI_LOADING';
const CLEAR_AI_MESSAGES = 'scratch-gui/ai-chat/CLEAR_AI_MESSAGES';
const SET_TOKEN_BALANCE = 'scratch-gui/ai-chat/SET_TOKEN_BALANCE';

const initialState = {
    isOpen: false,
    messages: [], // { role: 'user' | 'ai', content: '...', id: number }
    isLoading: false,
    tokenBalance: null
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case OPEN_AI_CHAT:
        return Object.assign({}, state, {isOpen: true});
    case CLOSE_AI_CHAT:
        return Object.assign({}, state, {isOpen: false});
    case TOGGLE_AI_CHAT:
        return Object.assign({}, state, {isOpen: !state.isOpen});
    case ADD_AI_MESSAGE:
        return Object.assign({}, state, {
            messages: state.messages.concat([action.message])
        });
    case SET_AI_LOADING:
        return Object.assign({}, state, {isLoading: action.isLoading});
    case CLEAR_AI_MESSAGES:
        return Object.assign({}, state, {messages: []});
    case SET_TOKEN_BALANCE:
        return Object.assign({}, state, {tokenBalance: action.balance});
    default:
        return state;
    }
};

const openAiChat = () => ({type: OPEN_AI_CHAT});
const closeAiChat = () => ({type: CLOSE_AI_CHAT});
const toggleAiChat = () => ({type: TOGGLE_AI_CHAT});
const addAiMessage = message => ({type: ADD_AI_MESSAGE, message});
const setAiLoading = isLoading => ({type: SET_AI_LOADING, isLoading});
const clearAiMessages = () => ({type: CLEAR_AI_MESSAGES});
const setTokenBalance = balance => ({type: SET_TOKEN_BALANCE, balance});

export {
    reducer as default,
    initialState as aiChatInitialState,
    openAiChat,
    closeAiChat,
    toggleAiChat,
    addAiMessage,
    setAiLoading,
    clearAiMessages,
    setTokenBalance
};
